import React from "react"
import { TableBody, TableHead, TableRow } from "@mui/material"
import { StyledTable, StyledHeaderCell, StyledBodyCell } from "../../../components/styled/StyledTableComponents"

const getPackagingsAndSubpackagingsNames = (packaging) => {
	let name = packaging.packagingName || ""
	if (packaging.subPackagings && packaging.subPackagings.length > 0) {
		name += ", " + packaging.subPackagings.map(sub => sub.subPackagingName).join(", ") + "."
	}
	return name
}

const PEPackagings = ({ packagings = [] }) => {
	return (
		<StyledTable>
			<TableHead>
				<TableRow>
					{["Barquettes", "Operculé", "Réemployable", "Jetable"].map(label => (
						<StyledHeaderCell key={label} py="16px" align="start">
							{label}
						</StyledHeaderCell>
					))}
				</TableRow>
			</TableHead>

			<TableBody>
				<TableRow>
					<StyledBodyCell leftEdge={true} lastTableRow={true}>Type</StyledBodyCell>
					{packagings.map((packaging, index) => (
						<StyledBodyCell key={index} rightEdge={index === packagings.length - 1} lastTableRow={true}>{getPackagingsAndSubpackagingsNames(packaging)}</StyledBodyCell>
					))}
				</TableRow>
			</TableBody>
		</StyledTable>
	)
}

export default PEPackagings